import { Box, Stack, TextareaAutosize } from "@mui/material";
import QRcode from "assets/images/tca/3/QRcodeFU03ThoughtRestructuring.png";
import { useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import ReactToPrint from "react-to-print";

import VideoBlock from "../VideoBlock";
import YmcaPageHeader from "../YmcaPageHeader";

const StageFollowup03 = ({ sendContractToBackend }) => {
  const formContext = useFormContext();
  const { control, watch } = formContext;
  const watchFieldsToPrint = watch([
    "smsFollowUp03.unproductiveThoughts",
    "smsFollowUp03.productiveThoughts",
  ]);
  const printTemplateRef = useRef();

  return (
    <>
      <Box className="greenContainer">
        <Box className="containerPadding">
          <Stack>
            <Box className="header1" mb={"20px"}>
              Follow Up Appointment 3
            </Box>
            <Box className="header2 green" mb={"16px"}>
              THOUGHT RESTRUCTURING
            </Box>
          </Stack>
          <VideoBlock
            thumbnail="https://img.youtube.com/vi/0zBllWeW0RQ/maxresdefault.jpg"
            youtubeLink={
              "https://www.youtube.com/watch?v=0zBllWeW0RQ&list=PLgBxj8BHl0M33FtRIckAJCR0JEjqz2ujJ&index=9"
            }
          >
            <>
              <Box className="text text-bold video-title" mt={0.75} mb={2}>
                Watch this video about Thought Restructuring to get started!
              </Box>
              <Box className="text text-bold">
                Thought Restructuring is the process of identifying an unproductive thought,
                stopping it and then replacing it with a more productive thought. If we let the
                unproductive thought take over, we'll be led down a path that we know isn't positive
                or beneficial.
              </Box>
            </>
          </VideoBlock>
          <Stack className="whiteBox" mb={"20px"}>
            <Box className="header2" mb={"11px"}>
              Here's an example of an unproductive thought:
            </Box>
            <Box>
              Today was such a long day at work, I think I'll just go home instead of going to work
              out.
              <br />
              <br />
              STOP the thought internally Replace with - I know I always feel better once I finish
              my workout <br />
              <br />
              and I could use a little downtime to watch my favorite show while exercising.
            </Box>
          </Stack>
          <Box className="text text-bold" mt={2.5} mb={2}>
            Take a few minutes and practice this 3-step process:
          </Box>
          <Box className="text">
            1. Identify the unproductive thought
            <br />
            <br />
            2. Yell STOP internally
            <br />
            <br />
            3. Replace the unproductive thought with something more positive.
          </Box>
          <Box className="text text-bold" mt={2} mb={2}>
            Think about a few thoughts that have derailed you in the past and write those below:
          </Box>
          <Controller
            name="smsFollowUp03.unproductiveThoughts"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <Stack spacing={1} mt={2} className="note-input-container">
                <TextareaAutosize
                  {...field}
                  aria-label="description textarea"
                  className="note-textarea"
                  placeholder="Please enter"
                />
              </Stack>
            )}
          />
          <Box className="text text-bold" mt={2} mb={2}>
            Now let's write out some positive and productive thoughts that we can use to replace the
            unproductive thoughts:
          </Box>
          <Controller
            name="smsFollowUp03.productiveThoughts"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <Stack spacing={1} mt={2} className="note-input-container">
                <TextareaAutosize
                  {...field}
                  aria-label="description textarea"
                  className="note-textarea"
                  placeholder="Please enter"
                />
              </Stack>
            )}
          />
        </Box>
        <hr className="containerDivider" />
        <Stack direction={"row"} justifyContent="space-around">
          <button type="button" className="action-button" onClick={() => sendContractToBackend()}>
            Email Document to the Member
          </button>
          <ReactToPrint
            trigger={() => (
              <button type="button" className="action-button">
                Print Document
              </button>
            )}
            content={() => printTemplateRef.current}
          />
        </Stack>
      </Box>
      <div className="out-of-sight">
        <Stack ref={printTemplateRef} className="elementToPrint">
          <YmcaPageHeader />
          <Stack direction={"row"} gap={2}>
            <img src={QRcode} width="114" height="114" />
            <Stack>
              <h1 style={{ color: "#00a98f" }}>THOUGHT RESTRUCTURING</h1>
              <Box mb={2}>
                <p>Watch this video about Thought Restructuring to get started!”</p>
              </Box>
              <Box>
                <p>
                  Thought Restructuring is the process of identifying an unproductive thought,
                  stopping it and then replacing it with a more productive thought. If we let the
                  unproductive thought take over, we'll be led down a path that we know isn't
                  positive or beneficial.
                </p>
              </Box>
            </Stack>
          </Stack>
          <Stack>
            <Box my={2}>
              <p>
                Here's an example of an unproductive thought:
                <br />
                Today was such a long day at work, I think I'll just go home instead of going to
                work out.
                <br />
                <br />
                STOP the thought internally Replace with - I know I always feel better once I finish
                my workout and I could use a little downtime to watch my favorite show while
                exercising.
              </p>
            </Box>
            <Box mb={2}>
              <p className="text orange text-bold">
                Take a few minutes and practice this 3-step process:
              </p>
            </Box>
            <div style={{ marginBottom: "8px", marginLeft: "16px" }}>
              <span>&#8226;</span> Identify the unproductive thought
            </div>
            <div style={{ marginBottom: "8px", marginLeft: "16px" }}>
              <span>&#8226;</span> Yell STOP internally
            </div>
            <div style={{ marginBottom: "16px", marginLeft: "16px" }}>
              <span>&#8226;</span> Replace the unproductive thought with something more positive.
            </div>
            <Box
              className="filledFormField p_wrap"
              style={{
                background: "#edf6ff",
                border: "dotted 1px #313a3d",
                padding: "10px",
                whiteSpace: "pre-line",
              }}
            >
              {watchFieldsToPrint[0]}
            </Box>
            <Box className="text" my={2}>
              <p>
                Now let's write out some positive and productive thoughts that we can use to replace
                the unproductive thoughts:
              </p>
            </Box>
            <Box
              className="filledFormField p_wrap"
              style={{
                background: "#edf6ff",
                border: "dotted 1px #313a3d",
                padding: "10px",
                whiteSpace: "pre-line",
              }}
            >
              {watchFieldsToPrint[1]}
            </Box>
          </Stack>
        </Stack>
      </div>
    </>
  );
};

export default StageFollowup03;
